// extracted by mini-css-extract-plugin
export var breadcrumb = "_1f-0";
export var breadcrumbArrow = "_1f-1";